// query-string >= 8 is ESM-only with a default export; @ihme/common and the app use named imports.
import queryString from '../node_modules/query-string/index.js';

export const { parse, stringify, parseUrl, stringifyUrl, extract } = queryString;
export default queryString;
